// extracted by mini-css-extract-plugin
module.exports = {"content":"content_content__ZopTc","scroll-wrapper":"content_scroll-wrapper__csmJt"};